// FIX-575: a codepromo-specific error was getting buried inside a generic
// modal (title = the API's overall error_message, content = every field
// error joined into one blob), which is what made two clients read the
// promo-code rejection as blocking their whole booking. Surface it on its
// own when it's the only field at fault.
const flattenFieldErrors = (entries) =>
  entries.flatMap(([, messages]) => [].concat(messages));

const buildCourseCreationErrorModal = (newCourse) => {
  const fieldErrors = newCourse.errors || {};
  const entries = Object.entries(fieldErrors);
  const codepromoErrors = fieldErrors.codepromo;
  const otherFieldErrors = flattenFieldErrors(
    entries.filter(([field]) => field !== 'codepromo'),
  );

  // Codepromo alone at fault: it becomes the whole message. `isCodepromoOnly`
  // lets the caller offer a way out — retrying the same booking without the
  // code — instead of leaving the client stuck re-typing a code they no
  // longer have (FIX-575: a "Non" typed into the field reads the same way).
  if (codepromoErrors && otherFieldErrors.length === 0) {
    return {
      title: [].concat(codepromoErrors).join(' '),
      content: '',
      isCodepromoOnly: true,
    };
  }

  // Otherwise keep the generic title and list EVERY field error, codepromo
  // included: dropping it here would hide the promo rejection behind an
  // unrelated one (e.g. an invalid address), which is the bug FIX-575 is
  // about, only one branch further along.
  return {
    title: newCourse.error_message,
    content: flattenFieldErrors(entries).join(','),
    isCodepromoOnly: false,
  };
};

export default buildCourseCreationErrorModal;
